import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { DEFAULT_LOCALE, LANGUAGES } from "./languages"

import enHome from "./locales/en/home.json"
import zhHkHome from "./locales/zh_HK/home.json"
import deHome from "./locales/de/home.json"
import deChHome from "./locales/de_CH/home.json"
import frHome from "./locales/fr/home.json"
import itHome from "./locales/it/home.json"
import esHome from "./locales/es/home.json"
import nlNlHome from "./locales/nl_NL/home.json"
import jaJpHome from "./locales/ja_JP/home.json"
import koKrHome from "./locales/ko_KR/home.json"

import enCommon from "./locales/en/common.json"
import zhHkCommon from "./locales/zh_HK/common.json"
import deCommon from "./locales/de/common.json"
import deChCommon from "./locales/de_CH/common.json"
import frCommon from "./locales/fr/common.json"
import itCommon from "./locales/it/common.json"
import esCommon from "./locales/es/common.json"
import nlNlCommon from "./locales/nl_NL/common.json"
import jaJpCommon from "./locales/ja_JP/common.json"
import koKrCommon from "./locales/ko_KR/common.json"

import enModal from "./locales/en/modal.json"
import zhHkModal from "./locales/zh_HK/modal.json"
import deModal from "./locales/de/modal.json"
import deChModal from "./locales/de_CH/modal.json"
import frModal from "./locales/fr/modal.json"
import itModal from "./locales/it/modal.json"
import esModal from "./locales/es/modal.json"
import nlNlModal from "./locales/nl_NL/modal.json"
import jaJpModal from "./locales/ja_JP/modal.json"
import koKrModal from "./locales/ko_KR/modal.json"

import enContact from "./locales/en/contact.json"
import zhHkContact from "./locales/zh_HK/contact.json"
import deContact from "./locales/de/contact.json"
import deChContact from "./locales/de_CH/contact.json"
import frContact from "./locales/fr/contact.json"
import itContact from "./locales/it/contact.json"
import esContact from "./locales/es/contact.json"
import nlNlContact from "./locales/nl_NL/contact.json"
import jaJpContact from "./locales/ja_JP/contact.json"
import koKrContact from "./locales/ko_KR/contact.json"

import enRewards from "./locales/en/rewards.json"
import zhHkRewards from "./locales/zh_HK/rewards.json"
import deRewards from "./locales/de/rewards.json"
import deChRewards from "./locales/de_CH/rewards.json"
import frRewards from "./locales/fr/rewards.json"
import itRewards from "./locales/it/rewards.json"
import esRewards from "./locales/es/rewards.json"
import nlNlRewards from "./locales/nl_NL/rewards.json"
import jaJpRewards from "./locales/ja_JP/rewards.json"
import koKrRewards from "./locales/ko_KR/rewards.json"

import enAbout from "./locales/en/about.json"
import zhHkAbout from "./locales/zh_HK/about.json"
import deAbout from "./locales/de/about.json"
import deChAbout from "./locales/de_CH/about.json"
import frAbout from "./locales/fr/about.json"
import itAbout from "./locales/it/about.json"
import esAbout from "./locales/es/about.json"
import nlNlAbout from "./locales/nl_NL/about.json"
import jaJpAbout from "./locales/ja_JP/about.json"
import koKrAbout from "./locales/ko_KR/about.json"

import enAccount from "./locales/en/account.json"
import zhHkAccount from "./locales/zh_HK/account.json"
import deAccount from "./locales/de/account.json"
import deChAccount from "./locales/de_CH/account.json"
import frAccount from "./locales/fr/account.json"
import itAccount from "./locales/it/account.json"
import esAccount from "./locales/es/account.json"
import nlNlAccount from "./locales/nl_NL/account.json"
import jaJpAccount from "./locales/ja_JP/account.json"
import koKrAccount from "./locales/ko_KR/account.json"

import enPdp from "./locales/en/pdp.json"
import zhHkPdp from "./locales/zh_HK/pdp.json"
import dePdp from "./locales/de/pdp.json"
import deChPdp from "./locales/de_CH/pdp.json"
import frPdp from "./locales/fr/pdp.json"
import itPdp from "./locales/it/pdp.json"
import esPdp from "./locales/es/pdp.json"
import nlNlPdp from "./locales/nl_NL/pdp.json"
import jaJpPdp from "./locales/ja_JP/pdp.json"
import koKrPdp from "./locales/ko_KR/pdp.json"

import enStockists from "./locales/en/stockists.json"
import zhHkStockists from "./locales/zh_HK/stockists.json"
import deStockists from "./locales/de/stockists.json"
import deChStockists from "./locales/de_CH/stockists.json"
import frStockists from "./locales/fr/stockists.json"
import itStockists from "./locales/it/stockists.json"
import esStockists from "./locales/es/stockists.json"
import nlNlStockists from "./locales/nl_NL/stockists.json"
import jaJpStockists from "./locales/ja_JP/stockists.json"
import koKrStockists from "./locales/ko_KR/stockists.json"

import enSizeGuide from "./locales/en/size-guide.json"
import zhHkSizeGuide from "./locales/zh_HK/size-guide.json"
import deSizeGuide from "./locales/de/size-guide.json"
import deChSizeGuide from "./locales/de_CH/size-guide.json"
import frSizeGuide from "./locales/fr/size-guide.json"
import itSizeGuide from "./locales/it/size-guide.json"
import esSizeGuide from "./locales/es/size-guide.json"
import nlNlSizeGuide from "./locales/nl_NL/size-guide.json"
import jaJpSizeGuide from "./locales/ja_JP/size-guide.json"
import koKrSizeGuide from "./locales/ko_KR/size-guide.json"

import enUsPricingUpdate from "./locales/en/us-pricing-update.json"
import zhHkUsPricingUpdate from "./locales/zh_HK/us-pricing-update.json"
import deUsPricingUpdate from "./locales/de/us-pricing-update.json"
import deChUsPricingUpdate from "./locales/de_CH/us-pricing-update.json"
import frUsPricingUpdate from "./locales/fr/us-pricing-update.json"
import itUsPricingUpdate from "./locales/it/us-pricing-update.json"
import esUsPricingUpdate from "./locales/es/us-pricing-update.json"
import nlNlUsPricingUpdate from "./locales/nl_NL/us-pricing-update.json"
import jaJpUsPricingUpdate from "./locales/ja_JP/us-pricing-update.json"
import koKrUsPricingUpdate from "./locales/ko_KR/us-pricing-update.json"

import enTariffs from "./locales/en/tariffs.json"
import zhHkTariffs from "./locales/zh_HK/tariffs.json"
import deTariffs from "./locales/de/tariffs.json"
import deChTariffs from "./locales/de_CH/tariffs.json"
import frTariffs from "./locales/fr/tariffs.json"
import itTariffs from "./locales/it/tariffs.json"
import esTariffs from "./locales/es/tariffs.json"
import nlNlTariffs from "./locales/nl_NL/tariffs.json"
import jaJpTariffs from "./locales/ja_JP/tariffs.json"
import koKrTariffs from "./locales/ko_KR/tariffs.json"

import enShippingInfo from "./locales/en/shipping-info.json"
import zhHkShippingInfo from "./locales/zh_HK/shipping-info.json"
import deShippingInfo from "./locales/de/shipping-info.json"
import deChShippingInfo from "./locales/de_CH/shipping-info.json"
import frShippingInfo from "./locales/fr/shipping-info.json"
import itShippingInfo from "./locales/it/shipping-info.json"
import esShippingInfo from "./locales/es/shipping-info.json"
import nlNlShippingInfo from "./locales/nl_NL/shipping-info.json"
import jaJpShippingInfo from "./locales/ja_JP/shipping-info.json"
import koKrShippingInfo from "./locales/ko_KR/shipping-info.json"

import enWishlist from "./locales/en/wishlist.json"
import zhHkWishlist from "./locales/zh_HK/wishlist.json"
import deWishlist from "./locales/de/wishlist.json"
import deChWishlist from "./locales/de_CH/wishlist.json"
import frWishlist from "./locales/fr/wishlist.json"
import itWishlist from "./locales/it/wishlist.json"
import esWishlist from "./locales/es/wishlist.json"
import nlNlWishlist from "./locales/nl_NL/wishlist.json"
import jaJpWishlist from "./locales/ja_JP/wishlist.json"
import koKrWishlist from "./locales/ko_KR/wishlist.json"

import enNotFound from "./locales/en/notFound.json"
import zhHkNotFound from "./locales/zh_HK/notFound.json"
import deNotFound from "./locales/de/notFound.json"
import deChNotFound from "./locales/de_CH/notFound.json"
import frNotFound from "./locales/fr/notFound.json"
import itNotFound from "./locales/it/notFound.json"
import esNotFound from "./locales/es/notFound.json"
import nlNlNotFound from "./locales/nl_NL/notFound.json"
import jaJpNotFound from "./locales/ja_JP/notFound.json"
import koKrNotFound from "./locales/ko_KR/notFound.json"

import enPrivacyPolicy from "./locales/en/privacyPolicy.json"
import zhHkPrivacyPolicy from "./locales/zh_HK/privacyPolicy.json"
import dePrivacyPolicy from "./locales/de/privacyPolicy.json"
import deChPrivacyPolicy from "./locales/de_CH/privacyPolicy.json"
import frPrivacyPolicy from "./locales/fr/privacyPolicy.json"
import itPrivacyPolicy from "./locales/it/privacyPolicy.json"
import esPrivacyPolicy from "./locales/es/privacyPolicy.json"
import nlNlPrivacyPolicy from "./locales/nl_NL/privacyPolicy.json"
import jaJpPrivacyPolicy from "./locales/ja_JP/privacyPolicy.json"
import koKrPrivacyPolicy from "./locales/ko_KR/privacyPolicy.json"

import enTermsConditions from "./locales/en/termsConditions.json"
import zhHkTermsConditions from "./locales/zh_HK/termsConditions.json"
import deTermsConditions from "./locales/de/termsConditions.json"
import deChTermsConditions from "./locales/de_CH/termsConditions.json"
import frTermsConditions from "./locales/fr/termsConditions.json"
import itTermsConditions from "./locales/it/termsConditions.json"
import esTermsConditions from "./locales/es/termsConditions.json"
import nlNlTermsConditions from "./locales/nl_NL/termsConditions.json"
import jaJpTermsConditions from "./locales/ja_JP/termsConditions.json"
import koKrTermsConditions from "./locales/ko_KR/termsConditions.json"

import enCookiePolicy from "./locales/en/cookiePolicy.json"
import zhHkCookiePolicy from "./locales/zh_HK/cookiePolicy.json"
import deCookiePolicy from "./locales/de/cookiePolicy.json"
import deChCookiePolicy from "./locales/de_CH/cookiePolicy.json"
import frCookiePolicy from "./locales/fr/cookiePolicy.json"
import itCookiePolicy from "./locales/it/cookiePolicy.json"
import esCookiePolicy from "./locales/es/cookiePolicy.json"
import nlNlCookiePolicy from "./locales/nl_NL/cookiePolicy.json"
import jaJpCookiePolicy from "./locales/ja_JP/cookiePolicy.json"
import koKrCookiePolicy from "./locales/ko_KR/cookiePolicy.json"

import enReviews from "./locales/en/reviews.json"
import zhHkReviews from "./locales/zh_HK/reviews.json"
import deReviews from "./locales/de/reviews.json"
import deChReviews from "./locales/de_CH/reviews.json"
import frReviews from "./locales/fr/reviews.json"
import itReviews from "./locales/it/reviews.json"
import esReviews from "./locales/es/reviews.json"
import nlNlReviews from "./locales/nl_NL/reviews.json"
import jaJpReviews from "./locales/ja_JP/reviews.json"
import koKrReviews from "./locales/ko_KR/reviews.json"

import enBikiniStyleGuide from "./locales/en/bikiniStyleGuide.json"
import zhHkBikiniStyleGuide from "./locales/zh_HK/bikiniStyleGuide.json"
import deBikiniStyleGuide from "./locales/de/bikiniStyleGuide.json"
import deChBikiniStyleGuide from "./locales/de_CH/bikiniStyleGuide.json"
import frBikiniStyleGuide from "./locales/fr/bikiniStyleGuide.json"
import itBikiniStyleGuide from "./locales/it/bikiniStyleGuide.json"
import esBikiniStyleGuide from "./locales/es/bikiniStyleGuide.json"
import nlNlBikiniStyleGuide from "./locales/nl_NL/bikiniStyleGuide.json"
import jaJpBikiniStyleGuide from "./locales/ja_JP/bikiniStyleGuide.json"
import koKrBikiniStyleGuide from "./locales/ko_KR/bikiniStyleGuide.json"

import enLookbooks from "./locales/en/lookbooks.json"
import zhHkLookbooks from "./locales/zh_HK/lookbooks.json"
import deLookbooks from "./locales/de/lookbooks.json"
import deChLookbooks from "./locales/de_CH/lookbooks.json"
import frLookbooks from "./locales/fr/lookbooks.json"
import itLookbooks from "./locales/it/lookbooks.json"
import esLookbooks from "./locales/es/lookbooks.json"
import nlNlLookbooks from "./locales/nl_NL/lookbooks.json"
import jaJpLookbooks from "./locales/ja_JP/lookbooks.json"
import koKrLookbooks from "./locales/ko_KR/lookbooks.json"

import enRequestReturn from "./locales/en/requestReturn.json"
import zhHkRequestReturn from "./locales/zh_HK/requestReturn.json"
import deRequestReturn from "./locales/de/requestReturn.json"
import deChRequestReturn from "./locales/de_CH/requestReturn.json"
import frRequestReturn from "./locales/fr/requestReturn.json"
import itRequestReturn from "./locales/it/requestReturn.json"
import esRequestReturn from "./locales/es/requestReturn.json"
import nlNlRequestReturn from "./locales/nl_NL/requestReturn.json"
import jaJpRequestReturn from "./locales/ja_JP/requestReturn.json"
import koKrRequestReturn from "./locales/ko_KR/requestReturn.json"

const resources = {
	en: { home: enHome, common: enCommon, modal: enModal, contact: enContact, rewards: enRewards, about: enAbout, account: enAccount, pdp: enPdp, stockists: enStockists, sizeGuide: enSizeGuide, usPricingUpdate: enUsPricingUpdate, tariffs: enTariffs, shippingInfo: enShippingInfo, wishlist: enWishlist, notFound: enNotFound, privacyPolicy: enPrivacyPolicy, termsConditions: enTermsConditions, cookiePolicy: enCookiePolicy, reviews: enReviews, bikiniStyleGuide: enBikiniStyleGuide, lookbooks: enLookbooks, requestReturn: enRequestReturn },
	zh_HK: { home: zhHkHome, common: zhHkCommon, modal: zhHkModal, contact: zhHkContact, rewards: zhHkRewards, about: zhHkAbout, account: zhHkAccount, pdp: zhHkPdp, stockists: zhHkStockists, sizeGuide: zhHkSizeGuide, usPricingUpdate: zhHkUsPricingUpdate, tariffs: zhHkTariffs, shippingInfo: zhHkShippingInfo, wishlist: zhHkWishlist, notFound: zhHkNotFound, privacyPolicy: zhHkPrivacyPolicy, termsConditions: zhHkTermsConditions, cookiePolicy: zhHkCookiePolicy, reviews: zhHkReviews, bikiniStyleGuide: zhHkBikiniStyleGuide, lookbooks: zhHkLookbooks, requestReturn: zhHkRequestReturn },
	de: { home: deHome, common: deCommon, modal: deModal, contact: deContact, rewards: deRewards, about: deAbout, account: deAccount, pdp: dePdp, stockists: deStockists, sizeGuide: deSizeGuide, usPricingUpdate: deUsPricingUpdate, tariffs: deTariffs, shippingInfo: deShippingInfo, wishlist: deWishlist, notFound: deNotFound, privacyPolicy: dePrivacyPolicy, termsConditions: deTermsConditions, cookiePolicy: deCookiePolicy, reviews: deReviews, bikiniStyleGuide: deBikiniStyleGuide, lookbooks: deLookbooks, requestReturn: deRequestReturn },
	de_CH: { home: deChHome, common: deChCommon, modal: deChModal, contact: deChContact, rewards: deChRewards, about: deChAbout, account: deChAccount, pdp: deChPdp, stockists: deChStockists, sizeGuide: deChSizeGuide, usPricingUpdate: deChUsPricingUpdate, tariffs: deChTariffs, shippingInfo: deChShippingInfo, wishlist: deChWishlist, notFound: deChNotFound, privacyPolicy: deChPrivacyPolicy, termsConditions: deChTermsConditions, cookiePolicy: deChCookiePolicy, reviews: deChReviews, bikiniStyleGuide: deChBikiniStyleGuide, lookbooks: deChLookbooks, requestReturn: deChRequestReturn },
	fr: { home: frHome, common: frCommon, modal: frModal, contact: frContact, rewards: frRewards, about: frAbout, account: frAccount, pdp: frPdp, stockists: frStockists, sizeGuide: frSizeGuide, usPricingUpdate: frUsPricingUpdate, tariffs: frTariffs, shippingInfo: frShippingInfo, wishlist: frWishlist, notFound: frNotFound, privacyPolicy: frPrivacyPolicy, termsConditions: frTermsConditions, cookiePolicy: frCookiePolicy, reviews: frReviews, bikiniStyleGuide: frBikiniStyleGuide, lookbooks: frLookbooks, requestReturn: frRequestReturn },
	it: { home: itHome, common: itCommon, modal: itModal, contact: itContact, rewards: itRewards, about: itAbout, account: itAccount, pdp: itPdp, stockists: itStockists, sizeGuide: itSizeGuide, usPricingUpdate: itUsPricingUpdate, tariffs: itTariffs, shippingInfo: itShippingInfo, wishlist: itWishlist, notFound: itNotFound, privacyPolicy: itPrivacyPolicy, termsConditions: itTermsConditions, cookiePolicy: itCookiePolicy, reviews: itReviews, bikiniStyleGuide: itBikiniStyleGuide, lookbooks: itLookbooks, requestReturn: itRequestReturn },
	es: { home: esHome, common: esCommon, modal: esModal, contact: esContact, rewards: esRewards, about: esAbout, account: esAccount, pdp: esPdp, stockists: esStockists, sizeGuide: esSizeGuide, usPricingUpdate: esUsPricingUpdate, tariffs: esTariffs, shippingInfo: esShippingInfo, wishlist: esWishlist, notFound: esNotFound, privacyPolicy: esPrivacyPolicy, termsConditions: esTermsConditions, cookiePolicy: esCookiePolicy, reviews: esReviews, bikiniStyleGuide: esBikiniStyleGuide, lookbooks: esLookbooks, requestReturn: esRequestReturn },
	nl_NL: { home: nlNlHome, common: nlNlCommon, modal: nlNlModal, contact: nlNlContact, rewards: nlNlRewards, about: nlNlAbout, account: nlNlAccount, pdp: nlNlPdp, stockists: nlNlStockists, sizeGuide: nlNlSizeGuide, usPricingUpdate: nlNlUsPricingUpdate, tariffs: nlNlTariffs, shippingInfo: nlNlShippingInfo, wishlist: nlNlWishlist, notFound: nlNlNotFound, privacyPolicy: nlNlPrivacyPolicy, termsConditions: nlNlTermsConditions, cookiePolicy: nlNlCookiePolicy, reviews: nlNlReviews, bikiniStyleGuide: nlNlBikiniStyleGuide, lookbooks: nlNlLookbooks, requestReturn: nlNlRequestReturn },
	ja_JP: { home: jaJpHome, common: jaJpCommon, modal: jaJpModal, contact: jaJpContact, rewards: jaJpRewards, about: jaJpAbout, account: jaJpAccount, pdp: jaJpPdp, stockists: jaJpStockists, sizeGuide: jaJpSizeGuide, usPricingUpdate: jaJpUsPricingUpdate, tariffs: jaJpTariffs, shippingInfo: jaJpShippingInfo, wishlist: jaJpWishlist, notFound: jaJpNotFound, privacyPolicy: jaJpPrivacyPolicy, termsConditions: jaJpTermsConditions, cookiePolicy: jaJpCookiePolicy, reviews: jaJpReviews, bikiniStyleGuide: jaJpBikiniStyleGuide, lookbooks: jaJpLookbooks, requestReturn: jaJpRequestReturn },
	ko_KR: { home: koKrHome, common: koKrCommon, modal: koKrModal, contact: koKrContact, rewards: koKrRewards, about: koKrAbout, account: koKrAccount, pdp: koKrPdp, stockists: koKrStockists, sizeGuide: koKrSizeGuide, usPricingUpdate: koKrUsPricingUpdate, tariffs: koKrTariffs, shippingInfo: koKrShippingInfo, wishlist: koKrWishlist, notFound: koKrNotFound, privacyPolicy: koKrPrivacyPolicy, termsConditions: koKrTermsConditions, cookiePolicy: koKrCookiePolicy, reviews: koKrReviews, bikiniStyleGuide: koKrBikiniStyleGuide, lookbooks: koKrLookbooks, requestReturn: koKrRequestReturn },
}

const RESERVED_OPTION_KEYS = new Set([
	"defaultValue",
	"lng",
	"ns",
	"keySeparator",
	"nsSeparator",
	"interpolation",
	"replace",
	"postProcess",
	"joinArrays",
	"returnObjects",
	"returnDetails",
	"context",
	"lngs",
])

const sprintfPostProcessor = {
	type: "postProcessor",
	name: "sprintf",
	process(value, _key, options) {
		if (typeof value !== "string" || value.indexOf("%") === -1) return value
		const positional = Object.entries(options || {})
			.filter(([k]) => !RESERVED_OPTION_KEYS.has(k))
			.map(([, v]) => v)
		return value.replace(/%(\d+)\$s/g, (match, num) => {
			const idx = parseInt(num, 10) - 1
			return positional[idx] !== undefined ? String(positional[idx]) : match
		})
	},
}

if (!i18n.isInitialized) {
	i18n.use(initReactI18next).use(sprintfPostProcessor).init({
		resources,
		lng: DEFAULT_LOCALE,
		fallbackLng: { de_CH: ["de", "en"], default: [DEFAULT_LOCALE] },
		supportedLngs: [...new Set(LANGUAGES.map((l) => l.locale))],
		defaultNS: "home",
		ns: ["home", "common", "modal", "contact", "rewards", "about", "account", "pdp", "stockists", "sizeGuide", "usPricingUpdate", "tariffs", "shippingInfo", "wishlist", "notFound", "privacyPolicy", "termsConditions", "cookiePolicy", "reviews", "bikiniStyleGuide", "lookbooks", "requestReturn"],
		interpolation: { escapeValue: false },
		postProcess: ["sprintf"],
		react: { useSuspense: false },
	})
}

export default i18n
